/**
 * @generated SignedSource<<c3300acdc249c500bc3a727bd6e88894>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateHeaderSectionContentfulRelayFragment$data = {
  readonly oneLinerHeadline: string | null | undefined;
  readonly pluginModuleKey: string | null | undefined;
  readonly templateNameExternal: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"templateAuthorContentfulRelayFragment">;
  readonly " $fragmentType": "templateHeaderSectionContentfulRelayFragment";
};
export type templateHeaderSectionContentfulRelayFragment$key = {
  readonly " $data"?: templateHeaderSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateHeaderSectionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateHeaderSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneLinerHeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluginModuleKey",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateAuthorContentfulRelayFragment"
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "8f8ff649db77b91366c4318c307ecb02";

export default node;
